const ViewObjective = ({ objective }) => (
  <div
    style={{
      borderBottom: "2px solid #dee2e6",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      wordBreak: "break-word",
    }}
    className="mb-3 pb-3"
  >
    <h6 className="fw-bold">{objective.objectiveName}</h6>
    <div dangerouslySetInnerHTML={{ __html: objective.description }}></div>
  </div>
);

export default ViewObjective;
